import axios from '../axios-init';

export const exportExcel = param => {
    return axios.get(param.url,{responseType: 'blob'}).then(res => {
        const blob = new Blob([res.data],{ type:"application/vnd.ms-excel"})
        const fileName = param.fileName;
        if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);// 释放URL 对象
            document.body.removeChild(elink);
        } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
        }
    }).catch(
        error => error);
};

export const postExportExcel = param => {
    return axios.post(param.url,param,{responseType: 'blob'}).then(res => {
        const blob = new Blob([res.data],{ type:"application/vnd.ms-excel"})
        const fileName = param.fileName;
        if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);// 释放URL 对象
            document.body.removeChild(elink);
        } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
        }
    }).catch(
        error => error);
};


// WEBPACK FOOTER //
// ./src/api/exportService.js